module.exports = "<p>\n  app-nav works!\n</p>\n"